var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('botao-tooltip',{attrs:{"icone":"mdi-delete","cor":"grey","texto":"Excluir"},on:{"click":_vm.excluir}})}
var staticRenderFns = []

export { render, staticRenderFns }